import { useEffect, useRef } from 'react';
import InteractionsList from '../../../interactions/InteractionsList';
import PermissionsView from '../../../Permissions/PermissionsView';
import ActivitiesList from '../../../activities/ActivitiesList';
import ContactsList from '../../../contacts/ContactsList';
import Profile from '../../../profile/Profile';
import PointsProgram from '../../../PointsProgram/PointsProgram';
import Exchange from '../../../exchange/Exchange';
import BondaLogin from '../../../bonda/BondaLogin';

// Vistas con listas sticky en desktop.
const STICKY_LIST_TABS = ['usuarios', 'interacciones', 'actividades', 'roles'];

const ViewLogin = (vm) => {
    const mainRef = useRef(null);
    const isStickyListView = STICKY_LIST_TABS.includes(vm.activeTab);

    useEffect(() => {
        if (vm.activeTab === 'inicio' && vm.init) {
            vm.initView(vm.permission, vm.setActiveTab);
        }
    }, [vm.activeTab, vm.init, vm.permission, vm.setActiveTab, vm.initView]);

    // Al abrir o redirigir a cualquier vista, dejar el scroll al inicio (arriba).
    useEffect(() => {
        if (mainRef.current) mainRef.current.scrollTop = 0;
        window.scrollTo(0, 0);
    }, [vm.activeTab]);

    return (
        <main ref={mainRef} className="flex-1 min-h-0 overflow-y-auto">
            {/* Scroll de página: la barra queda en el borde de la pantalla. Esta capa (color del
                fondo, fuera de las tarjetas) deja un pequeño espacio sobre el bloque fijo al hacer
                scroll (no queda pegado al header morado) y evita que el body se cuele por arriba. */}
            {isStickyListView && (
                <div aria-hidden="true" className="list-top-cover hidden md:block sticky top-0 z-40 h-3" />
            )}
            <div className={`${vm.activeTab === 'perfil'
                ? 'profile-view-shell min-h-full w-full px-1 pb-6 pt-4 sm:px-2 sm:pb-8 lg:px-3 xl:pb-4'
                : `container mx-auto px-4 pb-8 ${isStickyListView ? 'pt-4 md:pt-0' : 'pt-8'}`}`}>
                {vm.activeTab === 'perfil' &&
                    <Profile
                        user={vm.currentUser}
                        theme={vm.theme}
                        logout={vm.expireSesion}
                        message={vm.updateMessage}
                        setUser={vm.setCurrentUser}
                        permissions={vm.permission}
                        losesAccess={vm.losesAccess}
                        setProfile={vm.setActiveTab}
                        onLogout={vm.onLogout}
                    />}
                {vm.activeTab === 'usuarios' && 
                    <ContactsList
                        logout={vm.expireSesion}
                        permission={vm.permission}
                        message={vm.updateMessage}
                        losesAccess={vm.losesAccess}
                    />}
                {vm.activeTab === 'programa' &&
                    <PointsProgram
                        theme={vm.theme}
                        setProfile={vm.setActiveTab}
                        permissions={vm.permission}
                        losesAccess={vm.losesAccess}
                        message={vm.updateMessage}
                        logout={vm.expireSesion}
                    />}
                {vm.activeTab === 'interacciones' &&
                    <InteractionsList
                        mode="principal"
                        logout={vm.expireSesion}
                        losesAccess={vm.losesAccess}
                        permissions={vm.permission}
                        message={vm.updateMessage}
                    />}
                {vm.activeTab === 'actividades' &&
                    <ActivitiesList
                        logout={vm.expireSesion}
                        losesAccess={vm.losesAccess}
                        message={vm.updateMessage}
                    />}
                {vm.activeTab === 'roles' &&
                    <PermissionsView         
                        permissions={vm.permission} 
                        losesAccess={vm.losesAccess}              
                        message={vm.updateMessage}
                        logout={vm.expireSesion}
                    />}
                {vm.activeTab === 'bonda' &&
                    <BondaLogin />}
                {vm.activeTab === 'canje' && 
                    <Exchange
                        user={vm.currentUser}
                        logout={vm.expireSesion}
                        message={vm.updateMessage}
                        permissions={vm.permission}
                        losesAccess={vm.losesAccess}
                        setProfile={vm.setActiveTab}
                    />
                }
            </div>
        </main>
    );
};

export default ViewLogin;
